var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.957 8.5l4.338-4.356a.6.6 0 00.205-.461.62.62 0 00-.205-.478.62.62 0 00-.478-.205.6.6 0 00-.461.205L8 7.543l-4.356-4.34A.62.62 0 003.166 3a.653.653 0 00-.478.205.65.65 0 00-.188.478.6.6 0 00.205.461L7.043 8.5l-4.34 4.356a.62.62 0 00-.205.478c0 .182.063.342.188.478a.687.687 0 00.478.188.62.62 0 00.478-.205L8 9.44l4.356 4.356a.6.6 0 00.461.205.647.647 0 00.478-.188.654.654 0 00.205-.478.62.62 0 00-.205-.478L8.957 8.5z",
    fill: "currentColor"
  })));
}

export default SvgClose;